import { SummaryDataSource, SummaryType } from '@main-application/shared/services/summary-report-settings.service';
import { EIcon } from '@shared/enums/icon.enum';
import { UnitIcons } from '@shared/enums/unit-condition.enum';
import { UserType } from '@shared/enums/user-type';

export interface IRadioButtonOption<T> {
  value: T;
  label: string;
  groupValue?: string;
  groupLabel?: string;
  sort?: number | string;
  description?: string;
  disabled?: boolean;
  tooltip?: string;
  displayValue?: string;
  color?: string;
  hasBuildingNumber?: boolean;
  userGroupType?: UserType;
  additionalSearchLabel?: string;
  hidden?: boolean;
  icon?: EIcon | UnitIcons;
  summaryType?: SummaryType;
  dataSource?: SummaryDataSource;
  rolesHaveOnDashboard?: number[];
  isQuickSummary?: boolean;
  isNoReportsOption?: boolean;
}

export interface ITooltipRadioButtonOption<T> extends IRadioButtonOption<T> {
  tooltip: string;
}

export interface IUserRadioButtonOption<T> extends ITooltipRadioButtonOption<T> {
  userGroupType: UserType;
}

export function makeRadioButtonOptions(values: string[]): IRadioButtonOption<string>[] {
  return values.map(value => ({
    value: value,
    label: value,
  }));
}
